<div class="center-vertically">
    <div class="menu-container">
        <a href="/labels">
            <div class="menu-tile">
                <i class="fas fa-tags"></i>
                <span class="menu-title">Labels</span>
            </div>
        </a>

        <a href="/regels">
            <div class="menu-tile">
                <i class="fas fa-comment-dots"></i>
                <span class="menu-title">Aanvragen</span>
            </div>
        </a>

        <a href="/Identity/Account/Manage">
            <div class="menu-tile">
                <i class="fas fa-cog"></i>
                <span class="menu-title">Instellingen</span>
            </div>
        </a>

        <a href="/api/file/manual" target="_blank">
            <div class="menu-tile">
                <i class="fas fa-book"></i>
                <span class="menu-title">Handleiding</span>
            </div>
        </a>
    </div>
</div>